import { render } from "./EventEditForm.vue?vue&type=template&id=5b9c5ca3"
import script from "./EventEditForm.vue?vue&type=script&lang=ts"
export * from "./EventEditForm.vue?vue&type=script&lang=ts"
script.render = render

export default script